import Tippy from '@tippyjs/react';
import { ReactElement, ReactNode } from 'react';
import 'tippy.js/dist/tippy.css';
import './styles.scss';

interface TippyViewProps {
    children?: ReactElement;
    visible?: boolean;
    content: ReactNode;
    placement?: any;
    className?: string;
    interactive?: boolean;
    onClickOutside?: () => void;
}

export const TippyView = ({ children, visible, content, placement, className, interactive, onClickOutside }: TippyViewProps) => {
    return (
        <Tippy
            visible={visible}
            content={content}
            placement={placement}
            className={className}
            interactive={interactive}
            onClickOutside={onClickOutside}
            zIndex={1000}
        >
            {children}
        </Tippy>
    );
};
